
import ListV3 from './components/ListV3';

export default {
  i18nComponentKey: 'WidgetReviewsListV3.WidgetReviewsListV3Mobile',
  name: 'WidgetReviewsListV3Mobile',
  components: { ListV3 }
};
